// src/RuleConfirmationModal.jsx
import React from "react";

export default function RuleConfirmationModal({ tx, onConfirm, onConfirmSingle, onEdit, onCancel }) {
  const { vendor, suggestedCategory, suggestedSubcategory, amount, category } = tx;

  const transactionDetails = [
    vendor && `Vendor: "${vendor}"`,
    tx.bankCategory && `Bank Category: "${tx.bankCategory}"`,
    tx.accountName && `Account: "${tx.accountName}"`,
    tx.transactionType && `Type: "${tx.transactionType}"`,
    tx.mcc && `MCC: "${tx.mcc}"`,
    amount && `Amount: $${Math.abs(amount).toFixed(2)}`,
    tx.date && `Date: ${new Date(tx.date.seconds * 1000).toLocaleDateString()}`
  ].filter(Boolean).join(", ");

  const suggestedRule = [
    vendor && `Vendor: "${vendor}"`,
    tx.bankCategory && `Bank Category: "${tx.bankCategory}"`,
  ].filter(Boolean).join(", ");

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 40000,
    }}>
      <div style={{
        background: "#fff",
        padding: "2rem",
        borderRadius: "12px",
        maxWidth: "500px",
        width: "90%",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        textAlign: "left"
      }}>
        <h3>Confirm Rule</h3>
        <h4>This transaction:</h4>
        <p style={{ backgroundColor: "#f5f5f5", padding: "0.5rem", borderRadius: "6px" }}>{transactionDetails}</p>

        <h4>Suggested match:</h4>
        <ul>
          <li><strong>Category:</strong> {suggestedCategory}</li>
          <li><strong>Subcategory:</strong> {suggestedSubcategory || "None"}</li>
        </ul>

        <h4>Suggested rule:</h4>
        <p style={{ backgroundColor: "#f5f5f5", padding: "0.5rem", borderRadius: "6px" }}>{suggestedRule}</p>

        <p>Do you want to apply this rule to all future matching transactions?</p>

        <div style={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: "1rem", marginTop: "1rem" }}>
          <button
            onClick={onCancel}
            style={{
              backgroundColor: "#333",
              color: "white",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            onClick={onEdit}
            style={{
              backgroundColor: "#333",
              color: "white",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Edit Rule
          </button>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <button
              onClick={onConfirm}
              style={{
                backgroundColor: "#00B074",
                color: "white",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Confirm & Save Rule
            </button>
            <button
              onClick={onConfirmSingle}
              style={{
                backgroundColor: "#f0f0f0",
                color: "#333",
                border: "1px solid #ccc",
                padding: "0.5rem 1rem",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "0.9rem"
              }}
            >
              Confirm This Transaction Only
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}